import React, { useMemo } from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';
import dayjs from 'dayjs';
import ScrollContainer from 'react-indiana-drag-scroll';

import Table from '@components/Common/Table';

import { titleStyle } from '@styles/common';
import { palette } from '@styles/theme';

/** 포트폴리오 상세 > 성장정보 > 타임라인 */
const TimelineSkeleton = () => {
  /** 테이블 헤더 */
  const tableHeader = useMemo(
    () =>
      Array.from({ length: 12 }).map((_: any, i: number) => {
        const isUnder25 = Number(dayjs().format('D')) < 25 ? 1 : 0;

        return {
          value: dayjs()
            .subtract(12 - i + isUnder25, 'month')
            .format('YYYY-MM'),
          label: dayjs()
            .subtract(12 - i + isUnder25, 'month')
            .format('YYYY-MM'),
          textAlign: 'right',
        };
      }),
    []
  );

  /** 차트 및 테이블용 트래픽 데이터 가공 */
  const tableData = useMemo(
    () =>
      Array.from({ length: 3 }).map((_: any, i: number) => {
        const isUnder25 = Number(dayjs().format('D')) < 25 ? 1 : 0;

        return {
          id: i,
          title: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 0 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 1 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 2 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 3 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 4 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 5 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 6 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 7 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 8 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 9 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 10 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
          [`${dayjs()
            .subtract(12 - 11 + isUnder25, 'month')
            .format('YYYY-MM')}`]: (
            <div css={items}>
              <Skeleton variant="text" width={50} />
            </div>
          ),
        };
      }),
    []
  );

  return (
    <>
      <div css={titleStyle}>타임라인</div>
      <Skeleton
        variant="rectangular"
        height={440}
        sx={{
          borderRadius: '10px',
          boxShadow: '0px 0px 20px 0px rgba(206, 208, 214, 0.5)',
        }}
      />

      <ScrollContainer css={tableWrap} hideScrollbars={false}>
        <Table
          header={[{ label: '주요데이터', value: 'title' }, ...tableHeader]}
          data={tableData}
        />
      </ScrollContainer>
    </>
  );
};

export default TimelineSkeleton;

const tableWrap = css`
  margin-top: 40px;
  border-radius: 5px 5px 0 0;
  overflow-x: auto;
  padding: 1px;
  &::-webkit-scrollbar {
    width: 4px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${palette.gray4};
    height: 30%;
  }
  &::-webkit-scrollbar-track {
    background: ${palette.gray3};
  }

  table {
    width: calc(1920px - 250px - 82px);
  }
`;

const items = css`
  display: flex;
  justify-content: center;
`;
